import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TuiHintModule, TuiTextfieldControllerModule, TuiLabelModule } from "@taiga-ui/core";
import { TuiInputModule } from "@taiga-ui/kit";
import { KwikUIInputComponent } from "./input.component";

@NgModule({
  declarations: [KwikUIInputComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TuiHintModule,
    TuiInputModule,
    TuiTextfieldControllerModule,
    TuiLabelModule
  ],
  exports: [KwikUIInputComponent]
})
export class KwikUIInputModule {}
